import StatusChip, { STATUS_PALETTE } from '@components/StatusChip';
import { KnowledgeDocumentStatus } from '@constants/knowledge-base';
import { useTranslation } from '@hooks';

const STATUS_LOOKS = {
    [KnowledgeDocumentStatus.PROCESSING]: { tone: STATUS_PALETTE.warning, label: 'KnowledgeBase.processing' },
    [KnowledgeDocumentStatus.READY]: { tone: STATUS_PALETTE.success, label: 'KnowledgeBase.ready' },
    [KnowledgeDocumentStatus.FAILED]: { tone: STATUS_PALETTE.danger, label: 'KnowledgeBase.failed' },
};

const DocumentStatusChip = ({ status }: { status: number }) => {
    const { t } = useTranslation();
    const look = STATUS_LOOKS[status];
    return look ? <StatusChip bg={look.tone.bg} fg={look.tone.fg} label={t(look.label)} /> : null;
};

export default DocumentStatusChip;
